import { validateSchemaAsync } from '@/core/utils/safeSchemaValidations.ts'
import gestionApiService from '@/core/services/gestionApiService.ts'
import {
  Notification,
  NotificationListResponse,
  NotificationListResponseSchema,
  NotificationResponse,
  NotificationResponseSchema
} from '@/modules/utilities/notification/types/notification.ts'

export const NotificationService = {
  getAll: async (filters: string) =>
    validateSchemaAsync(
      NotificationListResponseSchema,
      gestionApiService.httpGET<NotificationListResponse>(
        `/notifications${filters ? filters : ''}`
      )
    ),
  getLast: async () =>
    validateSchemaAsync(
      NotificationResponseSchema,
      gestionApiService.httpGET<NotificationResponse>(`/notifications/last`)
    ),
  read: async (id: string) => {
    return gestionApiService.httpPUT<Notification>(
      `/notifications/${id}/read`,
      {}
    )
  },
  readAll: async () => {
    return gestionApiService.httpPUT<Notification>(
      `/notifications/read/all?read=true`,
      {}
    )
  }
}
